import React from "react";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import HeadingWithIcon from "Components/landing_page/HeadingWithIcon";
import { OurSubjectsContainer } from "./OurSubjects.style";

// Subject Images
import CivicsLogo from "Assets/Images/Subjects/civics_logo.png";
import ForeignLanguageLogo from "Assets/Images/Subjects/foreignlanguage_logo.png";
import EnglishLogo from "Assets/Images/Subjects/english_logo.png";
import EconomicsLogo from "Assets/Images/Subjects/economics_logo.png";
import HistoryLogo from "Assets/Images/Subjects/history_logo.png";
import MathLogo from "Assets/Images/Subjects/math_logo.png";
import ScienceLogo from "Assets/Images/Subjects/science_logo.png";
import { Link, useNavigate } from 'react-router-dom';
// Correct sequence
const subjectImages = [
    CivicsLogo,
    ForeignLanguageLogo,
    EnglishLogo,
    EconomicsLogo,
    HistoryLogo,
    MathLogo,
    ScienceLogo,
];

const OurSubjects = () => {

    const navigate = useNavigate();
    const handleOurSubjectsClick = () => {
        navigate("/subjects");
    };

    return (
        <OurSubjectsContainer>
            <div className="our_subjects_sections">
                <div className="mygrid-container">
                    <div className="mygrid-row">
                        {/* Left Content */}
                        <div className="mygrid-col-lg-6 mygrid-col-md-12">
                            <div className="our_sub_content">
                                <h5 className="subheading">Subjects</h5>
                                <HeadingWithIcon highlight="Subjects">Our</HeadingWithIcon>
                                <p>
                                    At Subjects Master, we make learning every subject fun,
                                    interactive, and easy to master. From Math and Science to
                                    History, Civics, English, Economics, and Foreign Languages, our
                                    platform offers games, quizzes, and activities that spark
                                    curiosity and build confidence. Whether you’re a student,
                                    parent, or teacher, our subjects are designed to make learning
                                    exciting, engaging, and effective for everyone.
                                </p>
                                <div className="intro_learnmore">
                                    <CustomButton onClick={handleOurSubjectsClick}
                                        text="Explore Our Subjects" />
                                </div>
                            </div>
                        </div>

                        {/* Right Images */}
                        <div className="mygrid-col-lg-6 mygrid-col-md-12">
                            <div className="sub-image-wrapper">
                                <ul className="subjects-images-list">
                                    {subjectImages.map((img, index) => (
                                        <li key={index}>
                                            <img src={img} alt={`Subject ${index + 1}`} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </OurSubjectsContainer>
    );
};

export default OurSubjects;
